if (!customElements.get('po-modal-video')) {
    class PoModalVideo extends HTMLElement {
        connectedCallback() {
            this.isOpening = false;
            this.isFullscreen = false;
            
            setTimeout(() => {
                this.modal = document.querySelector('#' + this.dataset.modalId);
                this.video = this.modal?.querySelector('video');
                this.cover = this.querySelector('[data-cover]');
                this.trigger = this.querySelector('[data-open-modal]');
                this.overlay = document.querySelector('#' + this.dataset.overlayId);
                this.closeModalTrigger = this.modal?.querySelector('.tw-po-modal-close');

                if (!this.trigger || !this.modal || !this.cover || !this.closeModalTrigger) {
                    return;
                }

                this.trigger.addEventListener('click', this.handleOpen);
                this.closeModalTrigger.addEventListener('click', this.handleClose);
                
                this.handleFullscreenChange = this.handleFullscreenChange.bind(this);
                document.addEventListener('fullscreenchange', this.handleFullscreenChange);
                document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
                document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
                document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
            }, 0);
        }
        
        disconnectedCallback() {
            document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
        }
        
        handleFullscreenChange = () => {
            const fullscreenElement = 
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            
            const isFullscreen = !!fullscreenElement;
            
            // Update our state
            if (isFullscreen) {
                this.isFullscreen = true;
            } else {
                // If user exits fullscreen (e.g., pressing ESC), clean up
                if (this.isFullscreen) {
                    this.isFullscreen = false;
                    this.cleanup();
                }
            }
        }
        
        cleanup = () => {
            if (this.fullscreenCloseBtn && this.fullscreenCloseBtn.parentNode) {
                this.fullscreenCloseBtn.parentNode.removeChild(this.fullscreenCloseBtn);
                this.fullscreenCloseBtn = null;
            }
            
            if (typeof this.modal.close === 'function') {
                this.modal.close();
            } else {
                this.modal.removeAttribute('open');
            }
            
            if (this.video) {
                this.video.pause();
                this.video.currentTime = 0;
            }
            
            this.overlay.classList.add('tw-animate-fade-out');
            setTimeout(() => {
                this.overlay?.classList.remove('!tw-block', 'tw-animate-fade-in');
            }, 400);
        }
        
        requestFullscreen = (element) => {
            if (element.requestFullscreen) {
                return element.requestFullscreen();
            } else if (element.webkitRequestFullscreen) {
                return element.webkitRequestFullscreen();
            } else if (element.mozRequestFullScreen) {
                return element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
                return element.msRequestFullscreen();
            }
            return Promise.reject(new Error('Fullscreen API not supported'));
        }
        
        exitFullscreen = () => {
            if (document.exitFullscreen) {
                return document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                return document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                return document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                return document.msExitFullscreen();
            }
            return Promise.resolve();
        }

        handleOpen = (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            if (this.isOpening) {
                return;
            }
            this.isOpening = true;
            
            this.openModal();
            
            setTimeout(() => {
                this.isOpening = false;
            }, 500);
        }

        handleClose = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.closeModal();
        }

        openModal = () => {
            this.classList.remove("tw-animate-shrink-fade-out");
            this.overlay.classList.remove('tw-animate-fade-out');
            
            if (this.video) {
                this.video.currentTime = 0;
                this.video.muted = true;
                this.video.setAttribute('webkit-playsinline', '');
                this.video.setAttribute('playsinline', '');
                
                const modalContent = this.modal.querySelector('.tw-po-modal-content');
                if (!modalContent) return;
                
                if (!this.fullscreenCloseBtn) {
                    this.fullscreenCloseBtn = document.createElement('button');
                    this.fullscreenCloseBtn.type = 'button';
                    this.fullscreenCloseBtn.innerHTML = '✕';
                    this.fullscreenCloseBtn.style.position = 'absolute';
                    this.fullscreenCloseBtn.style.top = '20px';
                    this.fullscreenCloseBtn.style.right = '20px';
                    this.fullscreenCloseBtn.style.zIndex = '10000';
                    this.fullscreenCloseBtn.style.width = '40px';
                    this.fullscreenCloseBtn.style.height = '40px';
                    this.fullscreenCloseBtn.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                    this.fullscreenCloseBtn.style.color = 'white';
                    this.fullscreenCloseBtn.style.border = 'none';
                    this.fullscreenCloseBtn.style.borderRadius = '50%';
                    this.fullscreenCloseBtn.style.cursor = 'pointer';
                    this.fullscreenCloseBtn.style.fontSize = '24px';
                    this.fullscreenCloseBtn.style.display = 'flex';
                    this.fullscreenCloseBtn.style.alignItems = 'center';
                    this.fullscreenCloseBtn.style.justifyContent = 'center';
                    this.fullscreenCloseBtn.style.transition = 'background-color 0.2s';
                    this.fullscreenCloseBtn.onmouseover = () => this.fullscreenCloseBtn.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                    this.fullscreenCloseBtn.onmouseout = () => this.fullscreenCloseBtn.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                    this.fullscreenCloseBtn.onclick = (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.closeModal();
                    };
                    modalContent.style.position = 'relative';
                    modalContent.appendChild(this.fullscreenCloseBtn);
                }
                
                if (typeof this.modal.show === 'function') {
                    try {
                        this.modal.show();
                    } catch (err) {
                        this.modal.setAttribute('open', '');
                    }
                } else {
                    this.modal.setAttribute('open', '');
                }
                
                setTimeout(() => {
                    this.requestFullscreen(modalContent).then(() => {
                        this.isFullscreen = true;
                        
                        const playPromise = this.video.play();
                        if (playPromise !== undefined) {
                            playPromise.catch(() => {
                                this.video.controls = true;
                            });
                        }
                    }).catch((err) => {
                        console.warn('Fullscreen request failed:', err);
                        this.closeModal();
                    });
                }, 50);
            }
        }

        closeModal = () => {
            if (this.isFullscreen) {
                this.exitFullscreen().then(() => {
                    this.isFullscreen = false;
                    this.cleanup();
                }).catch(() => {
                    this.isFullscreen = false;
                    this.cleanup();
                });
            } else {
                this.cleanup();
            }
        }
    }
    customElements.define("po-modal-video", PoModalVideo);
}